import Moment from 'moment';
import React, { useEffect, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { RightDirectionArrow } from '../../assets/images';
import { platformVersion } from '../../utils/excel-utils';
import { getStartEndDate } from '../CustomPicker/utils';
import history from './../../history';
import { SortIcon } from './../Icons';

const ProductsList = ({
  productList,
  selectedRange,
  pickerValue,
  endRange,
  startRange,
}) => {
  const data = productList?.details.filter(
    detail => detail.range.replace(/[^\d-]/g, '') === selectedRange
  )[0]?.data;
  const startRangeValue = startRange.replace(
    /^(\d+)(\.\d{0,2})?.*$/,
    (match, integerPart, decimalPart) => {
      if (!decimalPart) return `${integerPart}`;
      if (decimalPart.length === 2) return `${integerPart}${decimalPart}0`;
      return `${integerPart}${decimalPart.slice(0, 3)}`;
    }
  );
  const url = new URL(window.location.href);
  const variableType = url.searchParams.get('ut')
    ? url.searchParams.get('ut')
    : 'none';
  const [asc, setAsc] = useState(false);
  const [sortedData, setSortedData] = useState(
    data?.sort((a, b) => b.hours - a.hours)
  );
  const handleSort = () => {
    setSortedData([...sortedData].reverse());
    setAsc(!asc);
  };
  const [headerString, setHeader] = useState('');
  const setHeaderString = () => {
    if (variableType.includes('SoH')) {
      setHeader(`(${startRange})`);
    } else if (!endRange) {
      setHeader(`(${startRangeValue})`);
    } else {
      setHeader(`(${startRangeValue} - ${endRange})`);
    }
  };
  useEffect(() => {
    if (variableType.includes('SoH')) {
      setSortedData(data?.sort((a, b) => a.sohPercentage - b.sohPercentage));
    } else {
      setSortedData(data?.sort((a, b) => b.hours - a.hours));
    }

    setAsc(true);
  }, [data]);
  // Use effect to set the Header string on change of the header
  useEffect(() => {
    setHeaderString();
  }, [startRange]);
  const hasStringName = data?.some(detail => detail.stringName !== null);
  const makeRedirectLink = (rangeDetail, variable) => {
    let tabName = 'Usage';
    if (variable.includes('Temperature')) {
      variable = 'usgtemp';
    }
    if (variable.includes('SoC')) {
      variable = 'usgsoc';
    }
    if (variable.includes('Power')) {
      variable = 'usgpow';
    }
    if (variable.includes('Depth')) {
      variable = 'usgdod';
    }
    if (variable.includes('Time')) {
      variable = 'usgoh';
    }
    if (variable.includes('State of Health')) {
      tabName = 'SOH-vehicleprod-view';
    }
    const url = new URL(window.location.href);
    const searchParams = new URLSearchParams(url.search);
    const siteName = searchParams.get('st');
    const fleetName = searchParams.get('ft');
    const timeHorizom = searchParams.get('th');
    let { startDate, endDate } = getStartEndDate(timeHorizom);
    startDate = Moment(startDate)
      .subtract(1, 'days')
      .format('YYYY-MM-DDTHH:mm:ss');
    endDate = Moment(endDate).format('YYYY-MM-DDTHH:mm:ss');
    let newUrl = '';
    if (platformVersion() < '3') {
      newUrl = `/FleetView/VehicleView/VehicleProductsView?st=${siteName}&ft=${fleetName}&vc=${rangeDetail.vehicleName}&pdn=${rangeDetail.essName}&bpu=${rangeDetail.bpu}&tb=${tabName}&utb=${variable}&sdt=${startDate}&edt=${endDate}&pip=${rangeDetail.ipAddress}&vp=${rangeDetail.pec}&pickerValue=${pickerValue}&cdty=Custom`;
    } else {
      newUrl = `/FleetView/VehicleView/VehicleProductsView/PackView?st=${siteName}&ft=${fleetName}&fty=BESS&vc=${rangeDetail.vehicleName}&vp=${rangeDetail.pec}&pk=${rangeDetail.scu}&pkdn=${rangeDetail.stringName}&pip=${rangeDetail.ipAddress}&pdn=${rangeDetail.essName}&sdt=${startDate}&edt=${endDate}&tb=${tabName}&bpu=${rangeDetail.bpu}&scuID=${rangeDetail.scuid}&utb=${variable}&pickerValue=${pickerValue}&cdty=Custom`;
    }

    return newUrl.toString();
  };

  return (
    <div data-intro="fleet-satistics-list" style={{ minHeight: '300px' }}>
      <Row>
        <Col>
          <h5>
            {productList.xTitle}_Bin {headerString}
          </h5>
        </Col>
      </Row>
      <div style={{ width: '100%' }}>
        <table className="table table-hover table-borderless">
          <thead
            className="border-bottom border-black"
            style={{ fontSize: '14px' }}>
            <tr>
              <th scope="col">{platformVersion() < 3 ? 'Battery' : 'BS'}</th>
              {hasStringName ? <th>STRING</th> : ''}
              <th scope="col">Vehicle</th>
              <th
                scope="col"
                style={{ cursor: 'pointer' }}
                onClick={() => handleSort()}>
                {variableType === 'SoH' ? 'SoH' : 'Hours'}
                <SortIcon asc={asc} />
              </th>
            </tr>
          </thead>
          <tbody>
            {productList.details &&
              sortedData?.map((rangeDetail, idx) => (
                <tr
                  key={idx}
                  onClick={() => {
                    history.push(
                      makeRedirectLink(rangeDetail, productList.xTitle)
                    );
                  }}
                  style={{
                    border: 'none',
                    cursor: 'pointer',
                  }}>
                  <td>{rangeDetail.essName}</td>
                  {hasStringName ? <td>{rangeDetail.stringName}</td> : ''}
                  <td>{rangeDetail.vehicleDisplayName}</td>
                  <td>
                    {variableType === 'SoH'
                      ? rangeDetail.sohPercentage.toFixed(2)
                      : rangeDetail.hours.toFixed(2)}
                  </td>
                  <td>
                    <RightDirectionArrow
                      data={rangeDetail}
                      data-intro={idx === 0 ? 'fleet-satistics-arrow' : ''}
                    />
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ProductsList;
